import React, { Suspense, lazy } from "react";
import styled from "styled-components";
import { withTheme } from "@material-ui/styles";
import { SearchByHeader } from "../containers/Search";

const VINFormLazy = lazy(() => import("../components/VINForm"));

const Wrapper = withTheme(styled.div`
  width: 100%;
  box-sizing: border-box;
  max-width: 500px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`);

const SearchByVIN = ({ onSubmit, ...props }) => {
  return (
    <Wrapper {...props}>
      <SearchByHeader style={{ marginBottom: 20 }}>
        Search By <strong>VIN</strong>
      </SearchByHeader>
      <Suspense fallback={<div>Search by VIN</div>}>
        <VINFormLazy onSubmit={onSubmit} />
      </Suspense>
    </Wrapper>
  );
};

export default SearchByVIN;
